import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    controls: 'absolute z-2 flex',
    controlsInactive: '!op-0',
    nextControlHorizontal: 'top-1/2 transform -translate-y-1/2 right-0 justify-end',
    nextControlVertical: 'inset-x-0 justify-center my-4 bottom-0',
    previousControlHorizontal: 'top-1/2 transform -translate-y-1/2 left-0',
    previousControlVertical: 'inset-x-0 justify-center my-4 top-0',
    progressControls: 'p-4 pt-2 flex right-0 absolute z-10 lg:(p-6 bottom-0) <lg:top-0'
  }
} satisfies VfConfig['carousel']
